import * as React from 'react';
import { useCallback } from 'react';

import { translate } from '~l10n/client';

import { PaywallTouchEventAdapter } from '~analytics/adapters/PaywallTouchEventAdapter';
import { ViewPricingTableEventAdapter } from '~analytics/adapters/ViewPricingTableEventAdapter';
import { PaywallScreens } from '~analytics/types';
import { AlertMessage } from '~shared/components/AlertMessage';

interface Props {
  /* If false, this will show the inline paywall */
  canUseSharedLibraryQuizzes: boolean;
  /*What is the paywall screen last seen? This is used to send analytics
   * when purchasing a license */
  paywallScreen: PaywallScreens;
}

const billingPage = '/teacher/#profile/billing';

/*
 * component for showing an inline paywall if it's not possible to use shared library quizzes
 */
export function SharedLibraryUpgradeBanner({
  canUseSharedLibraryQuizzes,
  paywallScreen,
}: Props) {
  const sendAnalytics = useSendAnalytics(paywallScreen);

  if (canUseSharedLibraryQuizzes) return null;

  return (
    <div className="py-4 -mb-8">
      <AlertMessage tone="promote" align="center">
        {translate('Upgrade to Socrative Pro to use shared library content.')}{' '}
        <a onClick={sendAnalytics} href={billingPage}>
          {translate('Upgrade now')}
        </a>
      </AlertMessage>
    </div>
  );
}

function useSendAnalytics(paywallScreen: PaywallScreens) {
  return useCallback(() => {
    new PaywallTouchEventAdapter(paywallScreen).sendAnalytics();
    new ViewPricingTableEventAdapter({
      source: 'paywall',
      paywall_feature: paywallScreen,
    }).sendAnalytics();
  }, [paywallScreen]);
}
